import request from '@/config/axios'

// POI 分类 VO
export interface PoiCategoryVO {
  id: string | number
  name: string
  icon: string
  sort: number
  status: number
  createTime: Date
}

// POI VO
export interface PoiVO {
  id: string | number
  shopId: string | number
  poiCategoryId: string | number
  name: string
  address: string
  longitude: number
  latitude: number
  distance: number
  walkTime: string
  remark: string
  createTime: Date
}

// ======================= POI 分类 API =======================

// 获取POI分类分页
export function getPoiCategoryPage(params: any) {
  return request.get({ url: '/hotel/poi/category/page', params })
}

export function getPoiCategory(id: string | number) {
  return request.get({ url: '/hotel/poi/category/get?id=' + id })
}

// 获取全部POI分类（下拉选项用）
export function listAllCategories() {
  return request.get({ url: '/hotel/poi/category/page', params: { pageNo: 1, pageSize: 200 } })
}

// 创建POI分类
export function createPoiCategory(data: PoiCategoryVO) {
  return request.post({ url: '/hotel/poi/category/create', data })
}

// 更新POI分类
export function updatePoiCategory(data: PoiCategoryVO) {
  return request.put({ url: '/hotel/poi/category/update', data })
}

// 删除POI分类
export function deletePoiCategory(id: string | number) {
  return request.delete({ url: '/hotel/poi/category/delete?id=' + id })
}

// ======================= POI 数据 API =======================

// 获取POI分页
export function getPoiPage(params: any) {
  return request.get({ url: '/hotel/poi/list/page', params })
}

// 获取POI详情
export function getPoi(id: string | number) {
  return request.get({ url: '/hotel/poi/list/get?id=' + id })
}

// 创建POI
export function createPoi(data: PoiVO) {
  return request.post({ url: '/hotel/poi/list/create', data })
}

// 更新POI
export function updatePoi(data: PoiVO) {
  return request.put({ url: '/hotel/poi/list/update', data })
}

// 删除POI
export function deletePoi(id: string | number) {
  return request.delete({ url: '/hotel/poi/list/delete?id=' + id })
}
